import React from 'react';
import classNames from 'classnames';
import {ReactComponent as Icon} from 'images/icon/trigger-rename.svg';

export default class RenameIcon extends React.PureComponent {
  render() {
    return (
      <Icon
        className={classNames('icon rename', this.props.className)}
        onClick={this.props.onClick}
      />
    );
  }
}
